import {
  GET_ANNOUNCEMENT_DATA_REQUEST,
  GET_ANNOUNCEMENT_DATA_SUCCESS,
  GET_ANNOUNCEMENT_DATA_FAILURE,
  
  GET_ANNOUNCEMENT_DETAIL_REQUEST,
  GET_ANNOUNCEMENT_DETAIL_SUCCESS,
  GET_ANNOUNCEMENT_DETAIL_FAILURE,
  
  SET_SEEN_ANNOUNCEMENT_REQUEST,
  SET_SEEN_ANNOUNCEMENT_SUCCESS,
  SET_SEEN_ANNOUNCEMENT_FAILURE,
  
  GET_SEEN_ANNOUNCEMENT_COUNT_SUCCESS,
  
  GET_READ_ANNOUNCEMENT_COUNT_REQUEST,
  GET_READ_ANNOUNCEMENT_COUNT_SUCCESS,
  GET_READ_ANNOUNCEMENT_COUNT_FAILURE,

  SET_READ_ALL_ANNOUNCEMENT_REQUEST,
  SET_READ_ALL_ANNOUNCEMENT_SUCCESS,
  SET_READ_ALL_ANNOUNCEMENT_FAILURE
} from 'Store/constants';

const initialState = {
  announcementsList: {
    data: {},
    isLoading: false,
    isFetched: false,
    error: null
  },
  announcementsDetail: {
    data: {},
    isLoading: false,
    error: null
  },
  seenAnnouncements: {
    unseenNewsCount: 0,
    isLoading: false,
    error: null
  },
  readAnnouncements: {
    unreadAnnouncements: 0,
    isLoading: false,
    error: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ANNOUNCEMENT_DATA_REQUEST:
      return {
        ...state,
        announcementsList: {
          data: {},
          isLoading: true,
          isFetched: false,
          error: null
        }
      };
    case GET_ANNOUNCEMENT_DATA_SUCCESS:
      return {
        ...state,
        announcementsList: {
          data: action.payload,
          isLoading: false,
          isFetched: true,
          error: null
        }
      };
    case GET_ANNOUNCEMENT_DATA_FAILURE:
      return {
        ...state,
        announcementsList: {
          data: {},
          isLoading: false,
          isFetched: true,
          error: action.payload
        }
      };

    case GET_ANNOUNCEMENT_DETAIL_REQUEST:
      return {
        ...state,
        announcementsDetail: {
          data: {},
          isLoading: true,
          error: null
        }
      };
    case GET_ANNOUNCEMENT_DETAIL_SUCCESS:
      return {
        ...state,
        announcementsDetail: {
          data: action.payload,
          isLoading: false,
          error: null
        }
      };
    case GET_ANNOUNCEMENT_DETAIL_FAILURE:
      return {
        ...state,
        announcementsDetail: {
          data: {},
          isLoading: false,
          error: action.payload
        }
      };
      
    case SET_SEEN_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        seenAnnouncements: {
          ...state.seenAnnouncements,
          isLoading: true,
          error: null
        }
      };
    case SET_SEEN_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        seenAnnouncements: {
          unseenNewsCount: action.payload,
          isLoading: false,
          error: null
        }
      };
    case SET_SEEN_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        seenAnnouncements: {
          ...state.seenAnnouncements,
          isLoading: false,
          error: action.payload
        }
      };
    

    case GET_SEEN_ANNOUNCEMENT_COUNT_SUCCESS:
      return {
        ...state,
        seenAnnouncements: {
          unseenNewsCount: action.payload,
          isLoading: false,
          error: null
        }
      };

    case GET_READ_ANNOUNCEMENT_COUNT_REQUEST:
      return {
        ...state,
        readAnnouncements: {
          ...state.readAnnouncements,
          isLoading: true,
          error: null
        }
      };
    
    case GET_READ_ANNOUNCEMENT_COUNT_SUCCESS:
      return {
        ...state,
        readAnnouncements: {
          unreadAnnouncements: action.payload,
          isLoading: false,
          error: null
        }
      };
    
    case GET_READ_ANNOUNCEMENT_COUNT_FAILURE:
      return {
        ...state,
        readAnnouncements: {
          ...state.readAnnouncements,
          isLoading: false,
          error: action.payload
        }
      };

    case SET_READ_ALL_ANNOUNCEMENT_REQUEST:
      return {
        ...state,
        readAnnouncements: {
          ...state.readAnnouncements,
          isLoading: true,
          error: null
        }
      };
    case SET_READ_ALL_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        readAnnouncements: {
          unreadAnnouncements: action.payload,
          isLoading: false,
          error: null
        }
      };
        
    case SET_READ_ALL_ANNOUNCEMENT_FAILURE:
      return {
        ...state,
        readAnnouncements: {
          ...state.readAnnouncements,
          isLoading: false,
          error: action.payload
        }
      };

    default:
      return state;
  }
};
